'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import Link from '@eliadmin/core/src/components/link';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useOpenStaySignIn } from '@eliadmin/core/src/components/nt/shared/stay-sign-in-dialog';

/**
 * Buttons of the guest favourites (Figma 208:12680 „Actions“): „Prihlásiť sa“ opens the core
 * sign-in dialog (like the header user button), „Vytvoriť účet“ links to the core registration.
 * The page is static, so a signed-in visitor – also one who just signed in here – is sent to the
 * account favourites on the client (the core page redirected on the server).
 */
export function FavoritesGuestActions() {
  const { t } = useTranslations();
  const router = useRouter();
  const me = useCustomerStore(state => state.me);
  const locale = useLocaleStore(state => state.currentLocale);
  const openSignIn = useOpenStaySignIn();

  useEffect(() => {
    if (me) router.replace(ROUTES.FAVORITES());
  }, [me, router]);

  const warmUp = () => void prefetchSocialAuthProviders(locale);

  return (
    <>
      <Button
        variant="primary"
        size="md"
        iconLeft="user"
        aria-haspopup="dialog"
        onClick={() => {
          warmUp();
          openSignIn();
        }}
        onFocus={warmUp}
        onMouseEnter={warmUp}
      >
        {t('text189')}
      </Button>
      <Button asChild variant="outline" size="md">
        <Link href={ROUTES.REGISTER(ROUTES.FAVORITES()) ?? '#'} prefetch={false}>
          {t('text758')}
        </Link>
      </Button>
    </>
  );
}
